<script lang="ts" setup>
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~ds/components/ui/dropdown-menu';
import { Text } from '~ds/components/ui/typography';

import { EDUCATORS_ROUTE_LOGIN } from '~/constants/routes/educators';
import { UNIFIED_ROUTE_LOGIN } from '~/constants/routes/unified';

const { t } = useI18n();

const options = [
  {
    label: t('schools.landing.nav.signInMenu.teacher.label'),
    description: t('schools.landing.nav.signInMenu.teacher.description'),
    to: EDUCATORS_ROUTE_LOGIN,
    testId: 'schools-sign-in-menu-teacher',
  },
  {
    label: t('schools.landing.nav.signInMenu.student.label'),
    description: t('schools.landing.nav.signInMenu.student.description'),
    to: UNIFIED_ROUTE_LOGIN,
    testId: 'schools-sign-in-menu-student',
  },
];
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger
      class="px-4 py-2 text-sm font-semibold bg-secondary rounded-full text-nowrap cursor-pointer"
      data-testid="schools-sign-in-menu-trigger"
    >
      {{ t('unified.nav.signIn') }}
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" class="w-54">
      <DropdownMenuItem
        v-for="option in options"
        :key="option.to"
        as-child
        class="flex-col items-start gap-1.5 p-3 cursor-pointer"
      >
        <NuxtLink :to="option.to" :data-testid="option.testId">
          <Text
            as="span"
            size="sm"
            weight="semibold"
          >
            {{ option.label }}
          </Text>
          <Text as="span" size="xs">
            {{ option.description }}
          </Text>
        </NuxtLink>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
